export default __webpack_public_path__ + "media/images/manual/ic/03-52e794f0b1363300337e0cfaef497992.png";